var _rect, _text, _g, _g2, _g3, _g4, _g5, _text2, _text3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecisionFlow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mcpColor",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1d4ed8"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a2aColor",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8b5cf6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ec4899"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 280,
    fill: "#0f172a",
    rx: 12
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 35,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: "bold"
  }, "Which One Do You Need?")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 90)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -140,
    y: -25,
    width: 280,
    height: 50,
    rx: 25,
    fill: "#1e293b",
    stroke: "#f59e0b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontFamily: "Arial, sans-serif",
    fontSize: 13
  }, "Do agents need to talk to each other?"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(160, 140)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 50,
    stroke: "#ef4444",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,55 -6,45 6,45",
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("text", {
    x: -25,
    y: 30,
    fill: "#ef4444",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 12
  }, "NO"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(440, 140)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 50,
    stroke: "#22c55e",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,55 -6,45 6,45",
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 30,
    fill: "#22c55e",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 12
  }, "YES"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(160, 220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -30,
    width: 140,
    height: 60,
    rx: 12,
    fill: "url(#mcpColor)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.9;1;0.9",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 16
  }, "MCP"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 15,
    textAnchor: "middle",
    fill: "#bfdbfe",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, "Agent uses tools"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(440, 220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -30,
    width: 140,
    height: 60,
    rx: 12,
    fill: "url(#a2aColor)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.9;1;0.9",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 16
  }, "A2A"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 15,
    textAnchor: "middle",
    fill: "#ddd6fe",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, "Agents collaborate"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 265,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, sans-serif",
    fontSize: 9
  }, "APIs, databases, file ops")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 440,
    y: 265,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, sans-serif",
    fontSize: 9
  }, "Research, planning, review")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecisionFlow);
export default __webpack_public_path__ + "static/media/decision-flow.025f7bb1d6f6867a5290299aa7f9b319.svg";
export { ForwardRef as ReactComponent };